module.exports = __webpack_public_path__ + "img/swiper3.ae2756d4.png";